var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleLifestyle = function SvgCircleLifestyle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle_lifestyle_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "circle_lifestyle_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.25.25h29.5v29.5H.25V.25Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#circle_lifestyle_svg__b)",
    fill: "#7301B9",
    stroke: "#fff",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.729 0 0 6.729 0 15s6.729 15 15 15 15-6.729 15-15S23.271 0 15 0Zm0 28.378c-3.675 0-7.008-1.49-9.428-3.896a13.453 13.453 0 0 1-2.426-3.285A13.296 13.296 0 0 1 1.622 15C1.622 7.623 7.623 1.622 15 1.622c3.499 0 6.688 1.35 9.074 3.557a13.45 13.45 0 0 1 2.996 4.054A13.298 13.298 0 0 1 28.378 15c0 7.377-6.001 13.378-13.378 13.378Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.874 11.594c.596 0 1.117.313 1.386.803.216.392.558.778 1.006.778.448 0 .822-.368.714-.803-.35-1.41-1.61-2.4-3.106-2.4-1.495 0-2.755.99-3.105 2.4-.108.435.266.803.714.803.447 0 .79-.386 1.005-.778.27-.49.79-.803 1.386-.803ZM20.128 11.594c.596 0 1.117.313 1.386.803.216.392.558.778 1.006.778.448 0 .822-.368.713-.803-.35-1.41-1.61-2.4-3.105-2.4-1.495 0-2.755.99-3.105 2.4-.108.435.266.803.713.803.448 0 .79-.386 1.006-.778.27-.49.79-.803 1.386-.803ZM14.972 23.311a9.43 9.43 0 0 0 7.396-3.607c.275-.353.165-.858-.212-1.101-.376-.243-.874-.132-1.156.216a7.78 7.78 0 0 1-6.892 2.821c-1.989-.23-3.845-1.266-5.106-2.821-.282-.348-.78-.46-1.157-.216-.376.243-.487.747-.211 1.1 1.527 1.956 3.823 3.264 6.288 3.548.35.04.7.06 1.05.06Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle_lifestyle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgCircleLifestyle;